import axios from "axios";
import Vue from "vue";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  actions: {
    index({commit}) {
      return axios.get(process.env.VUE_APP_API_URL + 'extra-settings')
          .then(({data}) => {
            const items = data.filter((item) => item.open_frame);

            commit('setItems', items);
          });
    },
    setSelectedById({ commit, dispatch }, id) {
      commit('toggleSelectedById', id);

      dispatch('checkRules', id);
    },
    checkRules({commit, state, rootGetters}, id) {
      const activeTank = rootGetters['build/getTank'];
      const tankSpecificOptions = rootGetters['tanks/getTankSpecificOptions'](activeTank);
      const tankOptions = state.all.filter((item) => tankSpecificOptions.includes(item.id));

      const upperFrame = tankOptions.find((item) => item.type === 'open_frame_upper');
      const fuelTank = tankOptions.find((item) => item.type === 'open_frame_fuel_tank');
      const wheels = tankOptions.find((item) => item.type === 'open_frame_wheels');

      if (id !== upperFrame.id && fuelTank.selected && !upperFrame.selected) {
        //Fuel tank can not be selected without upper frame.
        commit('toggleSelectedById', upperFrame.id);
      }

      if (id === upperFrame.id && fuelTank.selected && !upperFrame.selected) {
        //Removing upper frame removes fuel tank as well.
        commit('toggleSelectedById', fuelTank.id);
      }

      if (id === wheels.id && wheels.selected && !upperFrame.selected) {
        //Adding wheels adds upper frame as well.
        commit('toggleSelectedById', upperFrame.id);
      }

      if (id === upperFrame.id && wheels.selected && !upperFrame.selected) {
        //Removing upper frame removes wheels as well.
        commit('toggleSelectedById', wheels.id);
      }
    },
    reset({commit}) {
      commit('reset');
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
    getBuildObject(state, getters, rootState) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push(option.id);
        }
      });

      return result;
    },

    getPriceObject(state) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push({'name': option.name.nl, 'price': option.price});
        }
      });

      return result;
    },

    reset({commit}) {
      commit('reset');
    }
  },

  mutations: {
    setItems(state, array) {
      state.all = array;
    },

    setSelected(state, {index, bool}) {
      state.all[index].selected = bool;
    },

    toggleSelectedById(state, optionId) {
      const optionIndex = state.all.findIndex((option) => option.id === optionId);

      if (optionIndex !== -1) {
        Vue.set(state.all[optionIndex], 'selected', !state.all[optionIndex].selected);
      }
    },

    reset(state) {
      state.all.forEach((option) => {
        option.selected = false;
      });
    },

    setSelect(state, array) {
      state.all = array;
    },

    toggleSelected(state, option) {
      Vue.set(option, 'selected', !option.selected);
    },
  },
}